import { graphql } from '../../services/graphql'

const INVENTORY_QUERY = `
  query getInventoryListPage($page: Page, $supplierId: Int) {

  inventoryListPage(page:$page, supplierId: $supplierId) {
    pagination {
      page
      pageSize
      rowCount
      pageCount
    }
    items {
      id
      supplier{
        id
        name
      }
      status {
        id
        code
        name
      }
      statusId
      createdAt
      createdBy
      taskId
      user {
        name
      }
      
    }
  }
}
`

const CREATE_INVENTORY_MUTATION = `
  mutation createInventory($supplierId: Int!) {
    createInventory( supplierId: $supplierId) {
      id
    } 
  }
`
const getters = {}
const state = {
  inventoryListPage: {},
  page: {
    number: 1,
    size: 25
  },
  supplierFilter: 0
}

const mutations = {
  updateInventories(state, inventories) {
    console.log('in mutation', inventories)
    inventories.items = inventories.items.map(item => {
      return { ...item, selected: false }
    })
    state.inventoryListPage = inventories
  },

  createInventory(state, inventory) {},

  changeSupplierFilter(state, value) {
    state.supplierFilter = +value
  },

  changeWarehouseFilter(state, value) {
    state.warehouseFilter = +value
  },

  nextInventoryPage(state) {
    console.log('next inventory page')
    state.page.number += 1
  },

  prevInventoryPage(state) {
    console.log('prev inventory page')

    if (state.page.number == 1) return

    state.page.number -= 1
  }
}

const actions = {
  getInventory({ commit, state }) {
    graphql()
      .request(INVENTORY_QUERY, {
        page: state.page,
        supplierId: state.supplierFilter
      })
      .then(data => {
        commit('updateInventories', data.inventoryListPage)
      })
  },
  createInventory({ commit, state }, data) {
    return graphql()
      .request(CREATE_INVENTORY_MUTATION, data)
      .catch(err => {
        return {
          error: true,
          message: err.response.errors[0].message
        }
      })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/components/inventory/inventory.store.js